import { Form, Input, Button, InputNumber, Switch, Space } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getCouponById, updateCoupon } from '../../store/slices/couponSlice';

const EditCoupon = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    useEffect(() => {
        fetchCoupon();
    }, [id]);

    const fetchCoupon = async () => {
        try {
            const result = await dispatch(getCouponById(id));

            if (getCouponById.fulfilled.match(result)) {
                form.setFieldsValue(result.payload);
            } else {
                setAlertMessage("Failed to load coupon");
            }
        } catch (err) {
            setAlertMessage("Error fetching coupon");
        }
    };

    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");

        try {
            const result = await dispatch(updateCoupon({ id, data: values }));

            if (updateCoupon.fulfilled.match(result)) {
                navigate('/coupon');
            } else {
                setAlertMessage(result?.payload?.error || 'Error updating coupon');
            }
        } catch (err) {
            setAlertMessage('Error updating coupon');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form form={form} onFinish={onSubmit} layout="vertical">
            <Form.Item
                name="code"
                label="Coupon Code"
                rules={[{ required: true }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                name="discount_percent"
                label="Discount %"
                rules={[{ required: true }]}
            >
                <InputNumber min={1} max={100} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item
                name="is_active"
                label="Active Status"
                valuePropName="checked"
            >
                <Switch />
            </Form.Item>

            {alertMessage && (
                <p style={{ color: 'red' }}>{alertMessage}</p>
            )}

            {/* <Button type="primary" htmlType="submit" loading={loading}>
                Update Coupon
            </Button> */}
            <Form.Item>
                <Space>
                    <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    size="large"
                    block
                    style={{
                        height: '48px',
                        fontSize: '16px',
                        fontWeight: 600,
                        borderRadius: '8px',
                    }}
                    >
                        Update Coupon
                    </Button>
                    <Button onClick={(e) => navigate(-1)}>Back</Button>
                </Space>
            </Form.Item>
        </Form>
    );
};

export default EditCoupon;